import { cn } from '@/lib/utils';

interface ChipSelectProps {
  options: readonly string[];
  selected: string[];
  onToggle: (item: string) => void;
  multiple?: boolean;
  disabled?: boolean;
  pending?: boolean;
}

/**
 * Chip-based multi/single select component for KYC survey.
 * Replicates the AngularJS chip selection UI.
 */
export function ChipSelect({ options, selected, onToggle, multiple = true, disabled = false, pending = false }: ChipSelectProps) {
  return (
    <div className={cn(
      'flex flex-wrap gap-2',
      pending && 'ring-2 ring-amber-400 rounded-lg p-2'
    )}>
      {options.map((option) => {
        const isSelected = selected.includes(option);
        return (
          <button
            key={option}
            type="button"
            disabled={disabled}
            onClick={() => onToggle(option)}
            className={cn(
              'px-3 py-1.5 rounded-full text-sm font-medium border transition-colors',
              isSelected
                ? 'bg-blue-500 text-white border-blue-500'
                : 'bg-white text-slate-600 border-slate-300 hover:border-blue-300',
              disabled && 'opacity-50 cursor-not-allowed',
            )}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
}
